module.exports = __webpack_public_path__ + "assets/img/file-tab.9af154a9.svg";